export const API_BASE_URL = process.env.REACT_APP_LOCAL_API_URL
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
export const PEGASUS_ADMIN = "admin"
export const STUDENT = "student"
export const SCHOOL = "school"
export const TYPE_ARRAY = ["admin","student" ,"school"]

